import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Stack,
  IconButton,
  Box,
} from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import axios from "axios";
import EditFineModal from "./Fine_edit";
import { BASE_URL } from "../../../../../Globalapi/Globalapi";

const FineTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const openModal = async () => {
    setIsModalOpen(true);
    setLoading(true);
    setError(null);

    try {
      const schoolId = sessionStorage.getItem("school_id");
      if (!schoolId) {
        setError("School ID is missing. Please ensure it is set.");
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `${BASE_URL}/admin/library/fine/list_fine.php?school_id=${schoolId}`
      );
      console.log("lib", response);

      if (response.data.success) {
        const fines = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setData(fines);
      } else {
        setError(response.data.message || "Failed to retrieve data.");
      }
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setData([]);
  };

  const deleteFine = async (id) => {
    setDeleteLoading(true);
    const schoolId = sessionStorage.getItem("school_id");

    if (!schoolId) {
      setError("School ID is missing. Please ensure it is set.");
      setDeleteLoading(false);
      return;
    }

    try {
      const response = await axios.delete(
        `${BASE_URL}/admin/library/fine/delete_fine.php`,
        {
          data: { id, school_id: schoolId },
        }
      );

      if (response.data.success) {
        setData((prevData) => prevData.filter((fine) => fine.id !== id));
        setError(null);
      } else {
        setError(response.data.message || "Failed to delete fine.");
      }
    } catch (err) {
      setError("Failed to delete fine. Please try again later.");
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <Box textAlign="right">
      <Button mb={0} mt={0} mr={5} colorScheme="teal" onClick={openModal}>
        View
      </Button>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          // bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            Fine Details
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            {loading && <p>Loading...</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}
            {!loading && !error && (
              <Table
                sx={{
                  "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
                }}
              >
                <Thead>
                  <Tr>
                    <Th>FineType</Th>
                    <Th>Fixed Amount</Th>
                    <Th>Details</Th>
                    <Th>Actions</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.length > 0 ? (
                    data.map((row) => {
                      // Parse fine_intervals safely
                      let fineIntervals = [];
                      try {
                        fineIntervals = JSON.parse(row.fine_intervals);
                        // Ensure it's an array
                        if (!Array.isArray(fineIntervals)) {
                          fineIntervals = [];
                        }
                      } catch {
                        fineIntervals = [];
                      }

                      return (
                        <Tr key={row.id}>
                          <Td>{row.fine_type || "N/A"}</Td>
                          <Td>{row.fixed_fine_amount || "N/A"}</Td>
                          <Td>
                            {fineIntervals.length > 0 ? (
                              fineIntervals.map((interval, index) => (
                                <div key={index}>
                                  <p>Days: {interval.days || "N/A"}</p>
                                  <p>Amount: {interval.fine_amount || "N/A"}</p>
                                </div>
                              ))
                            ) : (
                              <p>No intervals available</p>
                            )}
                          </Td>
                          <Td>
                            <Stack direction="row" spacing={2}>
                              <EditFineModal fineId={row.id} />
                              <IconButton
                                icon={<DeleteIcon />}
                                colorScheme="red"
                                size="sm"
                                onClick={() => deleteFine(row.id)}
                                aria-label="Delete record"
                                isLoading={deleteLoading}
                              />
                            </Stack>
                          </Td>
                        </Tr>
                      );
                    })
                  ) : (
                    <Tr>
                      <Td colSpan="4">No data available</Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            )}
          </ModalBody>
          <ModalFooter>
            {/* <Button variant="ghost" onClick={closeModal}>
              Close
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default FineTable;
